import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLeanpubComponent } from './simple-icons-leanpub.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLeanpubComponent ],
    exports:      [ SimpleIconsLeanpubComponent ],
    bootstrap:    []
})
export class SimpleIconsLeanpubModule {}
